import { ReactElement, useEffect, useId, useState } from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import { VoteStatus } from "./useVoteState";

import VoterCard from "../../common/Buttons/VoterCard";
import {
    CloseButton,
    customStylesModal,
    ModalBody,
    ModalHeader,
    ModalTitle,
} from "./ParticipantButton.styles";

type Props = {
    voteStatus: string;
    voterWeight: number;
    displayName: string;
    children: ReactElement;
};

const ParticipantButton = ({
    voteStatus,
    voterWeight,
    displayName,
    children,
}: Props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const titleId = useId();

    const { t } = useTranslation();

    useEffect(() => {
        if (VoteStatus.Success === voteStatus) {
            setModalIsOpen(false);
        }
    }, [voteStatus]);

    function toggleModal() {
        setModalIsOpen(!modalIsOpen);
    }

    return (
        <>
            <VoterCard
                displayName={displayName}
                handleClick={toggleModal}
                hasVoted={VoteStatus.Success === voteStatus}
                voterWeight={voterWeight}
            />
            <Modal
                closeTimeoutMS={200}
                isOpen={modalIsOpen}
                onRequestClose={toggleModal}
                aria={{ labelledby: titleId }}
                style={customStylesModal}
            >
                <ModalHeader>
                    <ModalTitle id={titleId}>{displayName}</ModalTitle>

                    <CloseButton
                        type="button"
                        onClick={toggleModal}
                        aria-label={t("close")}
                    >
                        <CloseIcon
                            aria-hidden="true"
                            style={{ fontSize: "20px", color: "#000" }}
                        />
                    </CloseButton>
                </ModalHeader>
                <ModalBody>{<>{children}</>}</ModalBody>
            </Modal>
        </>
    );
};

export default ParticipantButton;
